import validator from 'validator';

const validateEditPackage = (data) => {
    let errors = {};

    const { name,
    description,
    modal_info,
    original_price,
    discount} = data;

        if (validator.isEmpty(name)) {
            errors.name = '이름은 필수 입력 항목입니다. ';
        }
        if (!description) {
            errors.description = '필수 입력 사항입니다.';
        }
    
        if (!original_price) {
            errors.original_price = '필수 입력 사항입니다.';
        }
        if (!discount) {
            errors.discount = '필수 입력 사항입니다.';
        }
        if (!modal_info) {
            errors.modal_info = '설명은 필수 입력 사항입니다. ';
        }
        // if (!file) {
        //     errors.file = '파일을 업로드 해주세요';
        // }
        // if (validator.isEmpty(file)) {
        //     errors.file = '파일을 업로드 해주세요';
        // }
        // if (!ad_sub_type_id) {
        //     errors.ad_sub_type_id = '필수 입력 사항입니다.';
        // }
        // if (!ad_type_id) {
        //     errors.ad_type_id = '필수 입력 사항입니다.';
        // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateEditPackage;